<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" [formGroup]="formGroup">
  <div class="form-group col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <label for="{{controlId}}" class="control-label" *ngIf="showLabel">
      <span *ngIf="!label" i18n="@@animalNumber">Number</span>
      <span *ngIf="label">{{label}}</span>&nbsp;<span *ngIf="showRequired && required">*</span>
    </label>

    <input id="{{controlId}}" type="text" class="form-control text-uppercase" [formControlName]="controlName"
           [pattern]="animalDetail?.numberRegex" [readOnly]="readonly" [class.is-invalid]="showInvalid"
           [class.is-valid]="showValid" (change)="onChange($event)" (keypress)="keypress($event)">

    <div *ngIf="showInvalid" class="invalid-feedback">
      <div *ngIf="control?.hasError('required')" i18n="@@requiredInput">This input is required.</div>
      <div *ngIf="control?.hasError('unique')" i18n="@@uniqueInput">This input must be unique.</div>
      <div *ngIf="control?.hasError('pattern')" i18n="@@animalNumberPattern">{{animalDetail?.numberRegexMessage}}</div>
      <div *ngIf="control?.hasError('match')" i18n="@@animalNumberPattern">{{animalDetail?.numberRegexMessage}}</div>
    </div>
  </div>
</div>

